import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Location, PagedResult } from 'app/core/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';

@Injectable({
  providedIn: 'root'
})
export class LocationsApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
    private querify: QuerifyService
  ) { }

  search(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);
    return this.apollo
      .query({
        query: this.queries.locationsPaginated(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['locations'];
        })
      );
  }

  searchOne(locationId): Observable<Location> {
    return this.apollo
      .query({
        query: this.queries.searchLocation(),
        variables: { id: locationId }
      })
      .pipe(
        map(({ data }) => {
          return data['location'];
        })
      );
  }
}
